import React, { useContext, useRef } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Accordion } from '../Accordion';
import { AccordionGroup } from './AccordionGroup';
import { ComponentHeader } from '../ComponentHeader';
import { Button } from '../Buttons';
import media from '../../utils/media';
import { NAV_HEADER_HT } from '../../constants';
import { scrollTo } from '../../utils/transitions';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const Container = styled.section `
  outline: none;
  width: 100%;
  max-width: 1110px;
  margin: 0 auto 193px;

  ${media.mobile} {
    margin: 0 auto 24px;
  }

  .accordion-heading:hover {
    color: ${({ theme }) => theme.primaryRed};
  }

  .toggle-button {
    padding: 40px 20px;
    min-height: auto;
    justify-content: space-between;
    ${media.mobile} {
      padding: 20px 20px 0px;
      min-height: fit-content;
    }
  }
`;
const HeaderContainer = styled.div `
  ${media.mobile} {
    margin-bottom: 40px;
  }
`;
const ButtonContainer = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const FAQ = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { items: categoryItems, expandText, collapseText, componentTitle, componentSubtitle, buttonText, ariaLabel, } = fields;
    if (!categoryItems || categoryItems.length === 0) {
        return null;
    }
    const themeContext = useContext(ThemeContext);
    const ref = useRef(null);
    const { isWindowMobile } = themeContext;
    const navHeaderOffset = isWindowMobile ? NAV_HEADER_HT.TABLET : NAV_HEADER_HT.DESKTOP;
    return (React.createElement(Container, { ref: ref, "aria-label": ariaLabel && ariaLabel.value },
        React.createElement(HeaderContainer, null,
            React.createElement(ComponentHeader, { fields: { componentTitle, componentSubtitle } })),
        categoryItems.map(({ fields: categoryFields }, index) => {
            if (!categoryFields) {
                return null;
            }
            const { items: questionItems, questionCategoryTitle } = categoryFields;
            if (!questionItems || questionItems.length === 0) {
                return null;
            }
            return (React.createElement(Accordion, { key: index, data: questionItems, render: ({ isPanelOpen, togglePanel, openPanels, closePanels, isAllPanelsOpen, data }) => {
                    return (React.createElement(AccordionGroup, { data: data, collapseText: collapseText, expandText: expandText, questionCategoryTitle: questionCategoryTitle, isWindowMobile: isWindowMobile, openPanels: openPanels, closePanels: closePanels, isAllPanelsOpen: isAllPanelsOpen, isPanelOpen: isPanelOpen, togglePanel: togglePanel }));
                } }));
        }),
        buttonText && (React.createElement(ButtonContainer, null,
            React.createElement(OnClickFocusWrapper, null,
                React.createElement(Button, { isSecondary: true, onClick: () => {
                        setTimeout(() => {
                            scrollTo(0, ref.current.offsetTop - navHeaderOffset, 'smooth');
                        }, 250);
                    } }, buttonText.value))))));
};
